import Vue from 'vue'
import { API_URL } from '../../api'
import NewsFilter from '../../filters/NewsFilter';
const state = {
    newsCreate: {
        createdNews: null,
        creatingNews: false,
        createNewsStatus: null
    },
    newsUpdate: {
        updatedNews: null,
        updatingNews: false,
        updateNewsStatus: null
    },
    newsDelete: {
        deletingNews: false,
        deleteNewsStatus: null
    },
    newsSearch: {
        newsCount: null,
        news: [],
        searchingNews: false,
        searchNewsStatus: null
    },
}
const mutations = {
    ['SET_NEWS_CREATE'](state, change) {
        state.newsCreate = { ...state.newsCreate, ...change };
    },
    ['SET_NEWS_UPDATE'](state, change) {
        state.newsUpdate = { ...state.newsUpdate, ...change };
    },
    ['SET_NEWS_DELETE'](state, change) {
        state.newsDelete = { ...state.newsDelete, ...change };
    },
    ['SET_NEWS_SEARCH'](state, change) {
        state.newsSearch = { ...state.newsSearch, ...change };
    }
}
const actions = {
    createNews: ({ commit }, payload) => {
        commit('SET_NEWS_CREATE', { createNewsStatus: null, createdNews: null, creatingNews: true })
        return Vue.http.post(API_URL + '/news/create', payload).then(response => {
            commit('SET_NEWS_CREATE', { createNewsStatus: 'success', createdNews: response.body.results.news });
        }).catch(response => {
            commit('SET_NEWS_CREATE', { createNewsStatus: 'failed' });
        }).finally(() => {
            commit('SET_NEWS_CREATE', { creatingNews: false });
        });
    },
    updateNews: ({ commit }, payload) => {
        commit('SET_NEWS_UPDATE', { updateNewsStatus: null, updatedNews: null, updatingNews: true })
        return Vue.http.post(API_URL + '/news/update/' + payload.id, payload)
            .then(response => {
                commit('SET_NEWS_UPDATE', { updateNewsStatus: 'success', updatedNews: response.body.results.news });
            })
            .catch(response => {
                commit('SET_NEWS_UPDATE', { updateNewsStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_NEWS_UPDATE', { updatingNews: false });
            })
    },
    deleteNews: ({ commit }, id) => {
        commit('SET_NEWS_DELETE', { deleteNewsStatus: null, deletedNews: null, deletingNews: true })
        return Vue.http.delete(API_URL + '/news/delete/' + id).then(response => {
            commit('SET_NEWS_DELETE', { deleteNewsStatus: 'success' });
        }).catch(response => {
            commit('SET_NEWS_DELETE', { deleteNewsStatus: 'failed' });
        }).finally(() => {
            commit('SET_NEWS_DELETE', { deletingNews: false });
        })
    },
    searchNews: ({ commit }, payload = { filter: NewsFilter(), resultMode: 'default' }) => {
        commit('SET_NEWS_SEARCH', { searchNewsStatus: null, searchNews: null, searchingNews: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/news' + params).then(response => {
            commit('SET_NEWS_SEARCH', { searchNewsStatus: 'success', news: response.body.results.news });
        }).catch(response => {
            commit('SET_NEWS_SEARCH', { searchNewsStatus: 'failed' });
        }).finally(() => {
            commit('SET_NEWS_SEARCH', { searchingNews: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/newsStore.js